import { render, staticRenderFns } from "./ContactMessage.vue?vue&type=template&id=c95d492c&scoped=true"
import script from "./ContactMessage.vue?vue&type=script&lang=js"
export * from "./ContactMessage.vue?vue&type=script&lang=js"
import style0 from "./ContactMessage.vue?vue&type=style&index=0&id=c95d492c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95d492c",
  null
  
)

export default component.exports